import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth-container" }
const _hoisted_2 = { class: "auth-form-card" }
const _hoisted_3 = {
  key: 0,
  class: "success-message"
}
const _hoisted_4 = {
  key: 1,
  class: "error-message"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import type { TeacherProfile } from "@/stores/types";
import { apiUrl } from "@/config/api";

/**
 * UserLogin component for user authentication.
 * Emits events to communicate with the parent component (App.vue).
 */

interface LoginResponse {
  message: string;
  user: {
    id: number;
    email: string;
    name?: string;
  };
  profiles: TeacherProfile[];
}

interface LoginErrorResponse {
  error: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserLogin',
  props: {
    signupSuccessMessage: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const authStore = useAuthStore();

const email = ref("");
const password = ref("");
const errorMessage = ref("");

const handleLogin = async () => {
  errorMessage.value = ""; // Reset error message
  try {
    const response = await fetch(apiUrl("/login"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // Send cookies with the request
      body: JSON.stringify({
        email: email.value,
        password: password.value,
      }),
    });

    if (!response.ok) {
      const errorData = (await response.json()) as LoginErrorResponse;
      throw new Error(errorData.error || "Kirjautuminen epäonnistui");
    }

    const data = (await response.json()) as LoginResponse;

    // Store user and profiles data in Pinia store
    authStore.login(data.user, data.profiles);

    // After login, always go to profile selection
    await router.push("/profile-selection");

    // // Check if there are profiles to select
    // if (data.profiles && data.profiles.length > 0) {
    //   await router.push("/profile-selection");
    // } else {
    //   // This case might need specific handling, e.g., if a user MUST have a profile.
    //   // For now, we can redirect to assessments, but it might trigger the guard again.
    //   // A better approach might be to guide the user to create a profile.
    //   await router.push("/assessments");
    // }
  } catch (error: unknown) {
    if (error instanceof Error) {
      errorMessage.value = error.message;
    } else {
      errorMessage.value = "Tapahtui odottamaton virhe.";
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/'))),
        "aria-label": "Sulje"
      }, " ✕ "),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "auth-header" }, [
        _createElementVNode("h1", { class: "auth-title" }, "Kirjaudu sisään tai Luo tili aloittaaksesi")
      ], -1)),
      (props.signupSuccessMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.signupSuccessMessage), 1))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(errorMessage.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleLogin, ["prevent"]),
        class: "auth-form"
      }, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            id: "login-email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
            type: "email",
            placeholder: "Mikä on sähköpostiosoitteesi?",
            required: "",
            class: "form-input"
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            id: "login-password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
            type: "password",
            placeholder: "Salasanasi?",
            required: "",
            class: "form-input"
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("button", {
          type: "submit",
          class: "submit-button"
        }, "Kirjaudu sisään", -1))
      ], 32),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "auth-footer" }, [
        _createElementVNode("button", { class: "footer-link" }, "Unohtuiko salasana?")
      ], -1))
    ])
  ]))
}
}

})